import React from 'react';
import { MdMenu } from 'react-icons/md';

const Header = ({isSidebarOpen, setIsSidebarOpen}) => {
  return (
    <header className="fixed left-0 right-0 top-0 z-30 border-b border-slate-200 bg-white/95 shadow-sm backdrop-blur lg:left-64">
      <div className="flex h-16 items-center justify-between px-4 sm:px-6 lg:px-8">
        <button
          type="button"
          className="flex h-10 w-10 items-center justify-center rounded-md border border-slate-200 text-2xl text-slate-700 lg:hidden"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          aria-label="Open menu"
        >
          <MdMenu />
        </button>
        <div className="ml-auto text-sm font-semibold text-slate-500">
          Admin Panel
        </div>
      </div>
    </header>
  );
};

export default Header;
